import { forwardRef, type ReactNode } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface Props {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export const FadeInUp = forwardRef<HTMLDivElement, Props>(({ children, className = '', delay = 0 }, ref) => {
  const { ref: revealRef, visible } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref || revealRef}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
});

FadeInUp.displayName = 'FadeInUp';
